import { render, staticRenderFns } from "./pages2D.vue?vue&type=template&id=0341ebdc&scoped=true&"
import script from "./pages2D.vue?vue&type=script&lang=js&"
export * from "./pages2D.vue?vue&type=script&lang=js&"
import style0 from "./pages2D.vue?vue&type=style&index=0&id=0341ebdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0341ebdc",
  null
  
)

export default component.exports